/* src/app/shared/components/app-notifications/app-notifications.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
.component-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
  margin: 0 !important;
  width: 100%;
}
.matomo_notifications {
  text-align: left;
  font-size: 14px;
  letter-spacing: -0.14px;
  opacity: 1;
  font-family:
    "Inter",
    Arial,
    sans-serif;
}
#slide-card {
  height: calc(100vh - 70px);
  width: 600px !important;
  border: 1px solid #DFE0EB;
  border-radius: 0;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3333333333);
  padding: 0 14px 14px 14px !important;
  background-color: #F0F0F0;
}
#slide-card .mat-mdc-card-content {
  margin-top: 10px !important;
}
.notifications-title-container {
  margin-bottom: 15px !important;
  padding-left: 10px;
}
.notifications-title-container .notifications-title {
  font-size: 18px;
  color: #111111;
  font: normal normal normal 18px/22px var(--font-headline);
}
.notification_search {
  padding-top: 0.7em;
  display: inline-block;
  border-radius: 5px;
  width: 100% !important;
  margin-bottom: -25px !important;
}
.notification-container-header {
  background: #f8f8f8 0% 0% no-repeat padding-box;
  opacity: 1;
  border: 1px solid #DFE0EB;
  border-radius: 0;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3333333333);
  padding: 24px 14px 14px 14px !important;
}
.notification-content-section {
  overflow: overlay !important;
  height: calc(100vh - 255px) !important;
  width: 100% !important;
}
.notification-content-card {
  width: 100% !important;
}
.search-icon {
  opacity: 0.4;
}
.notification_none {
  padding-top: 75px;
  text-align: center;
}
.notification_none mat-icon {
  font-size: 137px !important;
}
.notification_none .notification_none_sub_text {
  margin-top: 20px;
}
mat-drawer {
  width: 100%;
}
.mat-mdc-card-content:last-child {
  padding-bottom: 0px !important;
}
.mat-mdc-header-row {
  background-color: #f8f8f8;
}
.mat-mdc-card {
  border: none !important;
}
.mat-mdc-card-header {
  border: 0 !important;
  padding: 0px !important;
}
.mat-mdc-card-content {
  padding: 0px !important;
  min-height: 500px !important;
}
.mat-mdc-card-title-toolbar {
  margin-left: auto;
  margin-right: 0;
  align-items: flex-start !important;
}
.mat-mdc-card-title-text {
  font-family:
    "Inter Bold",
    Arial,
    sans-serif !important;
}
.mat-tabs-border {
  border-bottom: 1px solid #DFE0EB;
}
::ng-deep .mat-drawer-inner-container {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  overflow: hidden !important;
}
::ng-deep .mat-drawer-container {
  z-index: 200 !important;
}
/*# sourceMappingURL=app-notifications.component.css.map */
